import { Model } from "@vuex-orm/core";

export class MProvince extends Model {
    static get entity() {
        return "m_provinces"
    }

    static fields() {
        return {
            "id": this.attr(null),
            "m_province_name": this.string(""),
            "create_by": this.attr(null),
            "update_by": this.attr(null),
            "createdAt": this.attr(null),
            "updatedAt": this.attr(null),
        }
    }

    static get apiConfig() {
        return {
            actions: {
                findAll(params = {}) {
                    return this.get('/m_province', { params });
                }
            }
        };
    }
}